import React from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useTheme } from '../context/ThemeContext';
import { useAuth } from '../context/AuthContext';
import ProtectedRoute from '../components/auth/ProtectedRoute';
import styles from '../styles/ModuleCard.module.css';

const modulosComunes = [
  {
    id: 'modulo-1',
    titulo: 'Módulo 1',
    descripcion: 'Formación avanzada sobre conducción racional basada en las normas de seguridad'
  },
  {
    id: 'modulo-3',
    titulo: 'Módulo 3',
    descripcion: 'Formación en primeros auxilios'
  },
  {
    id: 'modulo-4',
    titulo: 'Módulo 4',
    descripcion: 'Formación sobre sensibilización y educación vial'
  },
  {
    id: 'modulo-5',
    titulo: 'Módulo 5',
    descripcion: 'Formación sobre el tacógrafo digital'
  },
  {
    id: 'modulo-8',
    titulo: 'Módulo 8',
    descripcion: 'Protocolo de actuación para conductores ante un accidente'
  }
];

const modulosViajeros = [
  {
    id: 'modulo-2',
    titulo: 'Módulo 2',
    descripcion: 'Formación sobre el transporte escolar y de menores'
  },
  {
    id: 'modulo-6',
    titulo: 'Módulo 6',
    descripcion: 'Atención al cliente de transporte de viajeros'
  },
  {
    id: 'modulo-7',
    titulo: 'Módulo 7',
    descripcion: 'Atención e información a los viajeros del autobús'
  }
];

const modulosMercancias = [
  {
    id: 'modulo-2',
    titulo: 'Módulo 2',
    descripcion: 'Formación sobre el transporte de mercancías peligrosas'
  },
  {
    id: 'modulo-6',
    titulo: 'Módulo 6',
    descripcion: 'Gestión de carga y estiba de mercancías'
  },
  {
    id: 'modulo-7',
    titulo: 'Módulo 7',
    descripcion: 'Documentación y normativa específica de mercancías'
  }
];

const Modulos = () => {
  const navigate = useNavigate();
  const { isDarkMode } = useTheme();
  const { isAuthenticated } = useAuth();
  const [searchParams] = useSearchParams();
  const type = searchParams.get('type') || 'viajeros';

  const modulosEspecificos = type === 'viajeros' ? modulosViajeros : modulosMercancias;
  const todosLosModulos = [...modulosComunes, ...modulosEspecificos];

  return (
    <div className="container">
      <h1>Módulos de Estudio - {type === 'viajeros' ? 'Viajeros' : 'Mercancías'}</h1>
      <div className={styles.modulosGrid}>
        {todosLosModulos.map(modulo => (
          <div
            key={modulo.id}
            className={`${styles.moduleCard} ${isDarkMode ? styles.dark : ''}`}
            onClick={() => navigate(`/modulos/${modulo.id}?type=${type}`)}
          >
            <h3 className={styles.title}>
              {modulo.titulo}
            </h3>
            <p className={styles.description}>
              {modulo.descripcion}
            </p>
            <div className={styles.footer}>
              <span className={styles.startText}>
                Click para comenzar
              </span>
              <span className={styles.arrow}>→</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

const WrappedModulos = () => (
  <ProtectedRoute>
    <Modulos />
  </ProtectedRoute>
);

export default WrappedModulos;